/* BeautyKart — client interactions for custom sections */
(function () {
  'use strict';

  // FAQ accordions
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.bk-faq__q');
    if (q) {
      var item = q.closest('.bk-faq__item');
      var list = item.parentElement;
      var open = item.classList.contains('is-open');
      list.querySelectorAll('.bk-faq__item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('.bk-faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // Bestsellers carousel
    var carBtn = e.target.closest('.bk-carousel__btn');
    if (carBtn) {
      var track = carBtn.closest('.bk-section').querySelector('.bk-carousel__track');
      if (track) {
        var card = track.querySelector('.bk-card');
        var step = card ? card.offsetWidth + 16 : 320;
        var dir = carBtn.dataset.dir === 'prev' ? -1 : 1;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    // Quick add via Shopify ajax cart
    var addBtn = e.target.closest('[data-bk-add]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      var vid = addBtn.dataset.bkAdd;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.Shopify && window.Shopify.theme) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
          // Try to open Horizon's cart drawer
          var drawerBtn = document.querySelector('[ref="cartDrawerButton"], cart-icon, [data-cart-drawer-open]');
          if (drawerBtn) {
            drawerBtn.click();
          }
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }, 1600);
        });
    }
  });

  // Sticky announcement bar duplicate for infinite marquee
  document.querySelectorAll('.bk-announce__track').forEach(function (track) {
    var clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });
})();
